module.exports = __webpack_public_path__ + "img/lab.7f29af2c.png";